import type { SessionMonitorSession } from '@whiz-cart/node-shared/models/session/sessionMonitor';

export const formatDeviceName = (name: string, isMobile: boolean) => (isMobile ? `E${name.padStart(3, '0')}` : name);

export const deviceNameOrder = [
    (x: SessionMonitorSession) => !isNaN(Number(x.deviceId)) || x.isMobile,
    (x: SessionMonitorSession) => Number(x.deviceId),
    (x: SessionMonitorSession) => x.deviceId,
];
